import React from 'react';
import IconButton from '@mui/material/IconButton';

export default function ItrsIcon({ component: Component, onClick, disabled, sx = {} }) {
  return (
    <IconButton
      disabled={disabled}
      onClick={onClick}
      sx={{
        backgroundColor: '#1A76D2',
        color: 'white',
        '&:hover': { backgroundColor: '#1565C0' },
        '&.Mui-disabled': {
          backgroundColor: '#93b2c2',
          color: '#FFFFFF80',
        },
        borderRadius: '50%',
        ...sx,
      }}
      size="small"
    >
      <Component style={{ fontSize: '16px' }} />
    </IconButton>
  );
}
